var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcWalletWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5601 15.3002L13.8901 2.58018C13.2598 1.59418 12.1703 0.997559 11.0001 0.997559C9.82987 0.997559 8.74038 1.59418 8.1101 2.58018L0.440101 15.3002C-0.111353 16.2194 -0.130414 17.3631 0.390101 18.3002C0.992074 19.3553 2.11533 20.0048 3.3301 20.0002H18.6701C19.8766 20.0131 20.9979 19.3799 21.6101 18.3402C22.1462 17.3928 22.1271 16.2294 21.5601 15.3002ZM11.0001 16.0002C10.4478 16.0002 10.0001 15.5525 10.0001 15.0002C10.0001 14.4479 10.4478 14.0002 11.0001 14.0002C11.5524 14.0002 12.0001 14.4479 12.0001 15.0002C12.0001 15.5525 11.5524 16.0002 11.0001 16.0002ZM11.0001 13.0002C11.5524 13.0002 12.0001 12.5525 12.0001 12.0002V8.00018C12.0001 7.4479 11.5524 7.00018 11.0001 7.00018C10.4478 7.00018 10.0001 7.4479 10.0001 8.00018V12.0002C10.0001 12.5525 10.4478 13.0002 11.0001 13.0002Z",
    fill: "#FFAB00"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcWalletWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_wallet_warning.78e2ff8a50596e3a8af0ef3e2fa85dcd.svg";